/**
 * @flow
 * @relayHash 50dde6b2a80f8b8471da4c0b7c7c6c72
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CartItemInput = {
  vendor_variant_id: string,
  quantity: number,
  smart_cart_id?: ?string,
  variant_service_ids?: ?$ReadOnlyArray<?string>,
  guest_tokens?: ?$ReadOnlyArray<?string>,
};
export type ItemQuantityMutationVariables = {|
  input: CartItemInput
|};
export type ItemQuantityMutationResponse = {|
  +cart_add_item: {|
    +cart: ?{|
      +id: string,
      +ref_id: string,
      +name: ?string,
      +amount: number,
      +amount_in_qar: number,
      +quantity: number,
      +shipping_price: number,
      +raw_amount: number,
      +services_only: ?boolean,
      +least_state: ?string,
      +promo_code: ?string,
      +discount: number,
      +taxes: number,
      +selected_shipping_address: ?{|
        +ref_id: string
      |},
      +selected_billing_address: ?{|
        +ref_id: string
      |},
      +smart_cart: ?boolean,
      +user_smart_cart: ?boolean,
      +same_as_shipping: ?boolean,
      +payment_reference: ?string,
      +amount_with_cash: number,
      +amount_with_credit: number,
      +orders: $ReadOnlyArray<?{|
        +guest_token: ?string,
        +amount: number,
        +id: string,
        +product_type: ?string,
        +selected_billing_address_id: ?number,
        +selected_shipping_address_id: ?number,
        +same_as_shipping: ?boolean,
        +vendor_branch_id: ?number,
        +ref_id: string,
        +total: number,
        +notes: ?string,
        +state: string,
        +promo_total: number,
        +tax_total: number,
        +adjustment_total: number,
        +free_shipping: ?boolean,
        +available_payment_methods: ?$ReadOnlyArray<?{|
          +ref_id: string,
          +id: string,
          +name: string,
        |}>,
        +line_items: $ReadOnlyArray<?{|
          +created_at: ?any,
          +amount: number,
          +price: number,
          +warnings: ?$ReadOnlyArray<?{|
            +field: ?string,
            +messages: ?$ReadOnlyArray<?string>,
            +blocking: ?boolean,
          |}>,
          +id: string,
          +quantity: number,
          +variant_services: ?$ReadOnlyArray<?{|
            +ref_id: string
          |}>,
          +variant: {|
            +name: string,
            +id: string,
            +ref_id: string,
            +images: $ReadOnlyArray<?string>,
            +price: number,
            +slug: ?string,
            +vendor_variants_count: ?number,
            +min_variant: ?{|
              +vendor: ?{|
                +name: ?string,
                +ref_id: string,
              |}
            |},
            +total_on_hand: ?number,
            +display_price: ?string,
            +images_attachments: $ReadOnlyArray<?{|
              +url_original: string,
              +url_small: string,
            |}>,
            +option_values: ?$ReadOnlyArray<?{|
              +id: string,
              +name: ?string,
              +presentation: ?string,
            |}>,
            +vendor: ?{|
              +name: ?string,
              +active: ?boolean,
            |},
          |},
          +total: number,
        |}>,
        +vendor: {|
          +name: ?string,
          +branches: ?$ReadOnlyArray<?{|
            +ref_id: string,
            +name: string,
            +address: ?string,
            +lat: ?number,
            +lng: ?number,
            +inwani_building: ?number,
            +inwani_street: ?number,
            +inwani_zone: ?number,
          |}>,
          +payment_methods: $ReadOnlyArray<?{|
            +ref_id: string,
            +name: string,
          |}>,
        |},
        +vendor_branch: ?{|
          +ref_id: string,
          +name: string,
          +address: ?string,
          +lat: ?number,
          +lng: ?number,
          +inwani_building: ?number,
          +inwani_street: ?number,
          +inwani_zone: ?number,
        |},
        +payments: $ReadOnlyArray<?{|
          +payment_method: {|
            +ref_id: string,
            +name: string,
          |}
        |}>,
        +shipments: $ReadOnlyArray<?{|
          +ref_id: string,
          +shipping_rates: $ReadOnlyArray<?{|
            +ref_id: string,
            +base_price: ?number,
            +shipping_method: {|
              +calculator: ?{|
                +type: string
              |},
              +ref_id: string,
              +name: ?string,
              +estimated_delivery_time: ?string,
            |},
          |}>,
          +shipping_rate_selected: ?{|
            +ref_id: string,
            +base_price: ?number,
            +shipping_method: {|
              +calculator: ?{|
                +type: string
              |},
              +ref_id: string,
              +name: ?string,
              +estimated_delivery_time: ?string,
            |},
          |},
        |}>,
      |}>,
      +promotions: ?$ReadOnlyArray<?{|
        +ref_id: string,
        +code: ?string,
      |}>,
      +user: ?{|
        +avatar_details: ?{|
          +url_original: ?string,
          +name: ?string,
        |},
        +first_name: ?string,
        +last_name: ?string,
      |},
    |},
    +errors: ?$ReadOnlyArray<?{|
      +field: ?string,
      +messages: ?$ReadOnlyArray<?string>,
      +code: ?number,
    |}>,
  |}
|};
export type ItemQuantityMutation = {|
  variables: ItemQuantityMutationVariables,
  response: ItemQuantityMutationResponse,
|};
*/


/*
mutation ItemQuantityMutation(
  $input: CartItemInput!
) {
  cart_add_item(input: $input) {
    cart {
      id
      ref_id
      name
      amount
      amount_in_qar
      quantity
      shipping_price
      raw_amount
      services_only
      least_state
      promo_code
      discount
      taxes
      selected_shipping_address {
        ref_id
        id
      }
      selected_billing_address {
        ref_id
        id
      }
      smart_cart
      user_smart_cart
      same_as_shipping
      payment_reference
      amount_with_cash
      amount_with_credit
      orders {
        guest_token
        amount
        id
        product_type
        selected_billing_address_id
        selected_shipping_address_id
        same_as_shipping
        vendor_branch_id
        ref_id
        total
        notes
        state
        promo_total
        tax_total
        adjustment_total
        free_shipping
        available_payment_methods {
          ref_id
          id
          name
        }
        line_items {
          created_at
          amount
          price
          warnings {
            field
            messages
            blocking
          }
          id
          quantity
          variant_services {
            ref_id
            id
          }
          variant {
            name
            id
            ref_id
            images
            price
            slug
            vendor_variants_count
            min_variant {
              vendor {
                name
                ref_id
                id
              }
              id
            }
            total_on_hand
            display_price
            images_attachments {
              url_original
              url_small
            }
            option_values {
              id
              name
              presentation
            }
            vendor {
              name
              active
              id
            }
          }
          total
        }
        vendor {
          name
          branches {
            ref_id
            name
            address
            lat
            lng
            inwani_building
            inwani_street
            inwani_zone
            id
          }
          payment_methods {
            ref_id
            name
            id
          }
          id
        }
        vendor_branch {
          ref_id
          name
          address
          lat
          lng
          inwani_building
          inwani_street
          inwani_zone
          id
        }
        payments {
          payment_method {
            ref_id
            name
            id
          }
          id
        }
        shipments {
          ref_id
          shipping_rates {
            ref_id
            base_price
            shipping_method {
              calculator {
                type
                id
              }
              ref_id
              name
              estimated_delivery_time
              id
            }
            id
          }
          shipping_rate_selected {
            ref_id
            base_price
            shipping_method {
              calculator {
                type
                id
              }
              ref_id
              name
              estimated_delivery_time
              id
            }
            id
          }
          id
        }
      }
      promotions {
        ref_id
        code
        id
      }
      user {
        avatar_details {
          url_original
          name
        }
        first_name
        last_name
      }
    }
    errors {
      field
      messages
      code
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CartItemInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "CartItemInput!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "taxes",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount_in_qar",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "quantity",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "shipping_price",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "raw_amount",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "services_only",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "least_state",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "promo_code",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "discount",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "ref_id",
  "args": null,
  "storageKey": null
},
v15 = [
  v14
],
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "smart_cart",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "user_smart_cart",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "same_as_shipping",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "payment_reference",
  "args": null,
  "storageKey": null
},
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount_with_cash",
  "args": null,
  "storageKey": null
},
v21 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount_with_credit",
  "args": null,
  "storageKey": null
},
v22 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "state",
  "args": null,
  "storageKey": null
},
v23 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "guest_token",
  "args": null,
  "storageKey": null
},
v24 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "product_type",
  "args": null,
  "storageKey": null
},
v25 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "selected_billing_address_id",
  "args": null,
  "storageKey": null
},
v26 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "selected_shipping_address_id",
  "args": null,
  "storageKey": null
},
v27 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "vendor_branch_id",
  "args": null,
  "storageKey": null
},
v28 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "total",
  "args": null,
  "storageKey": null
},
v29 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "notes",
  "args": null,
  "storageKey": null
},
v30 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "promo_total",
  "args": null,
  "storageKey": null
},
v31 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "tax_total",
  "args": null,
  "storageKey": null
},
v32 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "adjustment_total",
  "args": null,
  "storageKey": null
},
v33 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "free_shipping",
  "args": null,
  "storageKey": null
},
v34 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "available_payment_methods",
  "storageKey": null,
  "args": null,
  "concreteType": "PaymentMethod",
  "plural": true,
  "selections": [
    v14,
    v3,
    v4
  ]
},
v35 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "created_at",
  "args": null,
  "storageKey": null
},
v36 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "price",
  "args": null,
  "storageKey": null
},
v37 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "field",
  "args": null,
  "storageKey": null
},
v38 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "messages",
  "args": null,
  "storageKey": null
},
v39 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "warnings",
  "storageKey": null,
  "args": null,
  "concreteType": "Error",
  "plural": true,
  "selections": [
    v37,
    v38,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "blocking",
      "args": null,
      "storageKey": null
    }
  ]
},
v40 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "vendor_variants_count",
  "args": null,
  "storageKey": null
},
v41 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "images",
  "args": null,
  "storageKey": null
},
v42 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "slug",
  "args": null,
  "storageKey": null
},
v43 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "total_on_hand",
  "args": null,
  "storageKey": null
},
v44 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "display_price",
  "args": null,
  "storageKey": null
},
v45 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "url_original",
  "args": null,
  "storageKey": null
},
v46 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "images_attachments",
  "storageKey": null,
  "args": null,
  "concreteType": "ImageAttachment",
  "plural": true,
  "selections": [
    v45,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "url_small",
      "args": null,
      "storageKey": null
    }
  ]
},
v47 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "option_values",
  "storageKey": null,
  "args": null,
  "concreteType": "OptionValue",
  "plural": true,
  "selections": [
    v3,
    v4,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "presentation",
      "args": null,
      "storageKey": null
    }
  ]
},
v48 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "active",
  "args": null,
  "storageKey": null
},
v49 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "address",
  "args": null,
  "storageKey": null
},
v50 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "lat",
  "args": null,
  "storageKey": null
},
v51 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "lng",
  "args": null,
  "storageKey": null
},
v52 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "inwani_building",
  "args": null,
  "storageKey": null
},
v53 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "inwani_street",
  "args": null,
  "storageKey": null
},
v54 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "inwani_zone",
  "args": null,
  "storageKey": null
},
v55 = [
  v14,
  v4,
  v49,
  v50,
  v51,
  v52,
  v53,
  v54
],
v56 = [
  v14,
  v4
],
v57 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "base_price",
  "args": null,
  "storageKey": null
},
v58 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v59 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "estimated_delivery_time",
  "args": null,
  "storageKey": null
},
v60 = [
  v14,
  v57,
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "shipping_method",
    "storageKey": null,
    "args": null,
    "concreteType": "VendorShippingMethod",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "calculator",
        "storageKey": null,
        "args": null,
        "concreteType": "Calculator",
        "plural": false,
        "selections": [
          v58
        ]
      },
      v14,
      v4,
      v59
    ]
  }
],
v61 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "code",
  "args": null,
  "storageKey": null
},
v62 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "user",
  "storageKey": null,
  "args": null,
  "concreteType": "UserPublicInfo",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "avatar_details",
      "storageKey": null,
      "args": null,
      "concreteType": "ImageDetails",
      "plural": false,
      "selections": [
        v45,
        v4
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "first_name",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "last_name",
      "args": null,
      "storageKey": null
    }
  ]
},
v63 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "errors",
  "storageKey": null,
  "args": null,
  "concreteType": "Error",
  "plural": true,
  "selections": [
    v37,
    v38,
    v61
  ]
},
v64 = [
  v14,
  v3
],
v65 = [
  v14,
  v4,
  v49,
  v50,
  v51,
  v52,
  v53,
  v54,
  v3
],
v66 = [
  v14,
  v4,
  v3
],
v67 = [
  v14,
  v57,
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "shipping_method",
    "storageKey": null,
    "args": null,
    "concreteType": "VendorShippingMethod",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "calculator",
        "storageKey": null,
        "args": null,
        "concreteType": "Calculator",
        "plural": false,
        "selections": [
          v58,
          v3
        ]
      },
      v14,
      v4,
      v59,
      v3
    ]
  },
  v3
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "ItemQuantityMutation",
  "id": null,
  "text": "mutation ItemQuantityMutation(\n  $input: CartItemInput!\n) {\n  cart_add_item(input: $input) {\n    cart {\n      id\n      ref_id\n      name\n      amount\n      amount_in_qar\n      quantity\n      shipping_price\n      raw_amount\n      services_only\n      least_state\n      promo_code\n      discount\n      taxes\n      selected_shipping_address {\n        ref_id\n        id\n      }\n      selected_billing_address {\n        ref_id\n        id\n      }\n      smart_cart\n      user_smart_cart\n      same_as_shipping\n      payment_reference\n      amount_with_cash\n      amount_with_credit\n      orders {\n        guest_token\n        amount\n        id\n        product_type\n        selected_billing_address_id\n        selected_shipping_address_id\n        same_as_shipping\n        vendor_branch_id\n        ref_id\n        total\n        notes\n        state\n        promo_total\n        tax_total\n        adjustment_total\n        free_shipping\n        available_payment_methods {\n          ref_id\n          id\n          name\n        }\n        line_items {\n          created_at\n          amount\n          price\n          warnings {\n            field\n            messages\n            blocking\n          }\n          id\n          quantity\n          variant_services {\n            ref_id\n            id\n          }\n          variant {\n            name\n            id\n            ref_id\n            images\n            price\n            slug\n            vendor_variants_count\n            min_variant {\n              vendor {\n                name\n                ref_id\n                id\n              }\n              id\n            }\n            total_on_hand\n            display_price\n            images_attachments {\n              url_original\n              url_small\n            }\n            option_values {\n              id\n              name\n              presentation\n            }\n            vendor {\n              name\n              active\n              id\n            }\n          }\n          total\n        }\n        vendor {\n          name\n          branches {\n            ref_id\n            name\n            address\n            lat\n            lng\n            inwani_building\n            inwani_street\n            inwani_zone\n            id\n          }\n          payment_methods {\n            ref_id\n            name\n            id\n          }\n          id\n        }\n        vendor_branch {\n          ref_id\n          name\n          address\n          lat\n          lng\n          inwani_building\n          inwani_street\n          inwani_zone\n          id\n        }\n        payments {\n          payment_method {\n            ref_id\n            name\n            id\n          }\n          id\n        }\n        shipments {\n          ref_id\n          shipping_rates {\n            ref_id\n            base_price\n            shipping_method {\n              calculator {\n                type\n                id\n              }\n              ref_id\n              name\n              estimated_delivery_time\n              id\n            }\n            id\n          }\n          shipping_rate_selected {\n            ref_id\n            base_price\n            shipping_method {\n              calculator {\n                type\n                id\n              }\n              ref_id\n              name\n              estimated_delivery_time\n              id\n            }\n            id\n          }\n          id\n        }\n      }\n      promotions {\n        ref_id\n        code\n        id\n      }\n      user {\n        avatar_details {\n          url_original\n          name\n        }\n        first_name\n        last_name\n      }\n    }\n    errors {\n      field\n      messages\n      code\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ItemQuantityMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "cart_add_item",
        "storageKey": null,
        "args": v1,
        "concreteType": "CartResult",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "cart",
            "storageKey": null,
            "args": null,
            "concreteType": "Cart",
            "plural": false,
            "selections": [
              v2,
              v3,
              v4,
              v5,
              v6,
              v7,
              v8,
              v9,
              v10,
              v11,
              v12,
              v13,
              v14,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "selected_shipping_address",
                "storageKey": null,
                "args": null,
                "concreteType": "Address",
                "plural": false,
                "selections": v15
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "selected_billing_address",
                "storageKey": null,
                "args": null,
                "concreteType": "Address",
                "plural": false,
                "selections": v15
              },
              v16,
              v17,
              v18,
              v19,
              v20,
              v21,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "orders",
                "storageKey": null,
                "args": null,
                "concreteType": "Order",
                "plural": true,
                "selections": [
                  v22,
                  v23,
                  v3,
                  v24,
                  v25,
                  v26,
                  v18,
                  v27,
                  v14,
                  v28,
                  v29,
                  v5,
                  v30,
                  v31,
                  v32,
                  v33,
                  v34,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "line_items",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "LineItem",
                    "plural": true,
                    "selections": [
                      v35,
                      v5,
                      v36,
                      v39,
                      v3,
                      v7,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "variant_services",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Variant",
                        "plural": true,
                        "selections": v15
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "variant",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Variant",
                        "plural": false,
                        "selections": [
                          v40,
                          v4,
                          v14,
                          v41,
                          v36,
                          v42,
                          v3,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "min_variant",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Variant",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "vendor",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Shop",
                                "plural": false,
                                "selections": [
                                  v4,
                                  v14
                                ]
                              }
                            ]
                          },
                          v43,
                          v44,
                          v46,
                          v47,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "vendor",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Shop",
                            "plural": false,
                            "selections": [
                              v4,
                              v48
                            ]
                          }
                        ]
                      },
                      v28
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "vendor",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Shop",
                    "plural": false,
                    "selections": [
                      v4,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "branches",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "VendorBranch",
                        "plural": true,
                        "selections": v55
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "payment_methods",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PaymentMethod",
                        "plural": true,
                        "selections": v56
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "vendor_branch",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "VendorBranch",
                    "plural": false,
                    "selections": v55
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "payments",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Payment",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "payment_method",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PaymentMethod",
                        "plural": false,
                        "selections": v56
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "shipments",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Shipment",
                    "plural": true,
                    "selections": [
                      v14,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "shipping_rates",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ShippingRate",
                        "plural": true,
                        "selections": v60
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "shipping_rate_selected",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ShippingRate",
                        "plural": false,
                        "selections": v60
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "promotions",
                "storageKey": null,
                "args": null,
                "concreteType": "Promotion",
                "plural": true,
                "selections": [
                  v14,
                  v61
                ]
              },
              v62
            ]
          },
          v63
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ItemQuantityMutation",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "cart_add_item",
        "storageKey": null,
        "args": v1,
        "concreteType": "CartResult",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "cart",
            "storageKey": null,
            "args": null,
            "concreteType": "Cart",
            "plural": false,
            "selections": [
              v2,
              v3,
              v4,
              v5,
              v6,
              v7,
              v8,
              v9,
              v10,
              v11,
              v12,
              v13,
              v14,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "selected_shipping_address",
                "storageKey": null,
                "args": null,
                "concreteType": "Address",
                "plural": false,
                "selections": v64
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "selected_billing_address",
                "storageKey": null,
                "args": null,
                "concreteType": "Address",
                "plural": false,
                "selections": v64
              },
              v16,
              v17,
              v18,
              v19,
              v20,
              v21,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "orders",
                "storageKey": null,
                "args": null,
                "concreteType": "Order",
                "plural": true,
                "selections": [
                  v22,
                  v23,
                  v3,
                  v24,
                  v25,
                  v26,
                  v18,
                  v27,
                  v14,
                  v28,
                  v29,
                  v5,
                  v30,
                  v31,
                  v32,
                  v33,
                  v34,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "line_items",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "LineItem",
                    "plural": true,
                    "selections": [
                      v35,
                      v5,
                      v36,
                      v39,
                      v3,
                      v7,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "variant_services",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Variant",
                        "plural": true,
                        "selections": v64
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "variant",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Variant",
                        "plural": false,
                        "selections": [
                          v40,
                          v4,
                          v14,
                          v41,
                          v36,
                          v42,
                          v3,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "min_variant",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Variant",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "vendor",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Shop",
                                "plural": false,
                                "selections": [
                                  v4,
                                  v14,
                                  v3
                                ]
                              },
                              v3
                            ]
                          },
                          v43,
                          v44,
                          v46,
                          v47,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "vendor",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Shop",
                            "plural": false,
                            "selections": [
                              v4,
                              v48,
                              v3
                            ]
                          }
                        ]
                      },
                      v28
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "vendor",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Shop",
                    "plural": false,
                    "selections": [
                      v4,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "branches",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "VendorBranch",
                        "plural": true,
                        "selections": v65
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "payment_methods",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PaymentMethod",
                        "plural": true,
                        "selections": v66
                      },
                      v3
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "vendor_branch",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "VendorBranch",
                    "plural": false,
                    "selections": v65
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "payments",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Payment",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "payment_method",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PaymentMethod",
                        "plural": false,
                        "selections": v66
                      },
                      v3
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "shipments",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Shipment",
                    "plural": true,
                    "selections": [
                      v14,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "shipping_rates",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ShippingRate",
                        "plural": true,
                        "selections": v67
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "shipping_rate_selected",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ShippingRate",
                        "plural": false,
                        "selections": v67
                      },
                      v3
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "promotions",
                "storageKey": null,
                "args": null,
                "concreteType": "Promotion",
                "plural": true,
                "selections": [
                  v14,
                  v61,
                  v3
                ]
              },
              v62
            ]
          },
          v63
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'fe305d6823b7ae4a2e2b259dbd172048';
module.exports = node;
